import {profileActionTypes} from './profile.actionTypes';
import {Network} from '../../../utils/network';
import AsyncStorage from '@react-native-async-storage/async-storage';
import {
  setCountry,
  setPartnerData,
  setRange,
  trackMoengageEvent,
} from '../../../utils/commonMethods';
import {headerSetPartner} from '../../../utils/networkFetch';
import {setIsLogin} from '../../../utils/commonredux/commonRedux.action';
import {logout} from '../../../utils/logOut';
import { createSmartAccountOwner, network } from '../../../lib/magic';

export const getBankDetails = () => async (dispatch, state) => {
  try {
    const res = await Network.getBankDetails();
    dispatch({
      type: profileActionTypes.SET_BANK_DETAILS,
      payload: res.data,
    });
  } catch (e) {
    dispatch({
      type: profileActionTypes.SET_BANK_DETAILS_ERROR,
      payload: e.response,
    });
  }
};

export const getUserPartnerProfile =
  (payload, auth_key) => async (dispatch, state) => {
    try {
      let reqObj = {payload: payload, auth_key: auth_key};
      const res = await Network.getUserPartnerProfile(reqObj, true);
      if (res?.data) {
        await logout();
        setCountry(res?.data?.region);
        setPartnerData(res?.data?.partner ?? 1);
        headerSetPartner(res?.data?.partner ?? 1);
        dispatch({
          type: profileActionTypes.SET_PROFILE,
          payload: res.data,
        });
      }
    } catch (e) {
      dispatch({
        type: profileActionTypes.SET_PROFILE_ERROR,
        payload: e.response,
      });
    }
  };

export const getUserProfile =
  (mobileNo, coupon, country, whatsapp, gToken, email, magicToken) =>
  async (dispatch, getState) => {
    try {
      let reqObj;
      if (email) {
        reqObj = {
          email: email,
          whatsapp_notif: whatsapp,
          isEmailVerified: true,
        };
      } else {
        reqObj = {
          mobile: mobileNo,
          country_code: country?.dial_code,
          signup_country: country?.code,
          whatsapp_notif: whatsapp,
        };
      }
      if (gToken) {
        delete reqObj.signup_country;
        reqObj = {...reqObj, ...gToken};
      }
      if (coupon) {
        reqObj = {...reqObj, coupon};
      }

      if (magicToken) {
        delete reqObj.signup_country;
        const smartAccountOwner = await createSmartAccountOwner(network);
        const address= await smartAccountOwner.getAddress();
        const meta = JSON.stringify(smartAccountOwner);
        const chainId = smartAccountOwner?.chain?.id;
        reqObj = {...reqObj, ...magicToken, scw: {
          address,
          meta,
          chainId
        }};
      }

      const fcmtoken = await AsyncStorage.getItem('fcmToken');

      if (fcmtoken) {
        reqObj = {...reqObj, fcmtoken};
      }
      const signup_country = getState()?.utilReducer?.globalConfigData?.detected_location;
      if(signup_country) {
        reqObj = {signup_country, ...reqObj};
      }
      const res = await Network.getUserProfile(reqObj);
      if (res?.data) {
        setCountry(res?.data?.region_code);
        setRange(res?.data?.user?.range_preference);
        dispatch({
          type: profileActionTypes.SET_PROFILE,
          payload: res.data,
        });
        localStorage.removeItem('selectedCountry');
      }
      if (gToken) return res;
      if (magicToken) return res;
    } catch (e) {
      dispatch({
        type: profileActionTypes.SET_PROFILE_ERROR,
        payload: e.response,
      });
    }
  };

export const setProfileEmpty = data => async (dispatch, state) => {
  dispatch({
    type: profileActionTypes.SET_PROFILE,
    payload: data ? data : null,
  });
};

export const getUser = isFireCTEvent => async (dispatch, state) => {
  try {
    const res = await Network.getUser();
    if (res?.data?.user) {
      if (isFireCTEvent) {
        trackMoengageEvent('User Login', {
          signUpCountry: res?.data?.user?.signup_country,
          userLevel: res?.data?.user?.level,
        });
      }

      setCountry(res?.data?.user?.region_code);
      setRange(res?.data?.user?.range_preference);
      dispatch({
        type: profileActionTypes.SET_PROFILE,
        payload: res.data.user,
      });
    }

    // console.log(`getuser API - ${JSON.stringify(res.data.user)}`);
  } catch (e) {
    dispatch({
      type: profileActionTypes.SET_PROFILE_ERROR,
      payload: e.response,
    });
  }
};

export const getReferralData = () => async (dispatch, state) => {
  try {
    const res = await Network.getReferralData();
    dispatch({
      type: profileActionTypes.SET_REFERRAL_DATA,
      payload: res.data,
    });
  } catch (e) {
    dispatch({
      type: profileActionTypes.SET_REFERRAL_ERROR,
      payload: e.response,
    });
  }
};

export const setUserProfileAfterLogin = () => async (dispatch, state) => {
  try {
    const user = JSON.parse(await AsyncStorage.getItem('userProfile'));

    if (user) {
      dispatch(setIsLogin(true));
      dispatch({
        type: profileActionTypes.SET_PROFILE,
        payload: user,
      });
    }
  } catch (e) {
    dispatch({
      type: profileActionTypes.SET_PROFILE_ERROR,
      payload: e.response,
    });
  }
};
